import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 35000,
});

const NET_MSG = "Connessione lenta o assente. Controlla la rete e riprova.";
const BUSY_MSG = "Il servizio è momentaneamente occupato. Riprova tra qualche secondo.";

api.interceptors.response.use(undefined, (error) => {
  const status = error.response?.status;
  if (!error.response) error.response = { status: 0, data: { detail: NET_MSG } };
  else if (status >= 500) error.response.data = { detail: BUSY_MSG };
  return Promise.reject(error);
});

export function apiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
